UsersIndex

<template>
	<div id="wrapper">
		<SidebarView :voucher="true" :voucher-index="true" :voucher-visible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header d-flex flex-row align-items-center justify-content-between">
									<h6 class="m-0 fw-bold text-green">
										All Vouchers
									</h6>
									<div class="d-flex">
										<b-button class="btn btn-sm akkurate-green-btn" href="/voucher/create"
											variant="primary">
											<span class="akkurate-small">
												<i class="fas fa-plus"></i> Add
												Voucher</span>
										</b-button>
										<div>
											<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
										</div>
									</div>

								</div>
								<div class="row text-center my-2">
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-green rounded-circle" />
											Total Request Amount<br />
											{{ institution.currency_code }}
											{{
												displayNumber(
													Number(
														total_amount_requested
													).toFixed(2)
												)
											}}
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-danger rounded-circle" />
											Total Approved Amount <br />
											{{ institution.currency_code }}
											{{
												displayNumber(
													Number(
														total_amount_approved
													).toFixed(2)
												)
											}}
										</p>
									</div>
								</div>
								<hr class="m-0" />
								<div class="card-body py-3 default_bg" style="
										border-bottom: 1px solid
											rgb(1, 134, 115);
									">
									<div class="home-box border border-success p-3 bg-white">
										<form @submit.prevent="filterTable">
											<journal-voucher-filter :form="form" :users_options="users_options"
												:branch_options="branch_options
													"></journal-voucher-filter>
										</form>
									</div>
								</div>
								<div class="card-body pt-3">
									<div class="table_text_size">
										<b-table striped bordered responsive="lg" id="voucher-table" :busy.sync="isBusy"
											:items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #cell(created_by)="data">
												<div>
													{{
														data.item.created_by?.first_name
													}}
													{{
														data.item.created_by?.surname
													}}
												</div>
											</template>
											<template #cell(reference)="data">
												<b-link v-if="data.item.status == 'DISBURSED'"
													v-b-tooltip.hover="{ variant: 'info' }"
													title="Click to view ledger entries"
													class="text-decoration-none akkurate-green"
													:href="`/chart-of-accounts/transactions?reference=VOU${data.item.id}`">
													VOU{{ data.item.id }}
												</b-link>
												<div v-else>
													VOU{{ data.item.id }}
												</div>
											</template>
											<!-- <template #cell(reference)="data">
												<div>
													VOU{{ data.item.id }}
												</div>
											</template> -->
											<template #cell(status)="data">
												<span :class="statusBadge(
													data.item?.status
												)
													">{{
														data.item?.status
													}}</span>
											</template>
											<template #empty="scope">
												<h4 class="text-center small mt-3">
													{{ scope.emptyText }}
												</h4>
											</template>
											<template #cell(actions)="data">
												<span class="d-flex">
													<voucher-view :data="data.item
														"></voucher-view>
													<a v-if="
														data.item.status !=
														'REJECTED' &&
														data.item.status !=
														'APPROVED' &&
														data.item.status !=
														'DISBURSED' &&
														data.item.status !=
														'REVERSED'
													" title="Approve" class="btn btn-sm akkurate-green-btn text-white broder-0 custom-pointer"
														:href="`/voucher/approve/${data.item.id}`">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'check',
														]" /></span>
													</a>
													<a v-if="status_permission" title="Edit" class="btn btn-sm akkurate-blue text-white border-0"
														:href="`/voucher/${data.item.id}/edit`">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'edit',
														]" /></span>
													</a>
													<reject :data="data.item" @rejected="
														rejected
													"></reject>
													<a v-if="data.item.status == 'APPROVED'" :disabled="isDisbursing"
														title="Disburse" @click="disburseVoucher(data.item.id)"
														class="btn btn-sm akkurate-gray-btn text-white custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'exchange-alt',
														]" /></span>
													</a>
													<a v-if="
														data.item.status ==
														'DISBURSED'
													" @click="
														printVoucher(
															data.item
														)
														" class="btn btn-sm akkurate-green-btn text-white custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'book',
														]" /></span>
													</a>
													<a title="download" target="_blank" v-if="
														data.item
															?.receipt_location !=
														undefined
													" :href="configBase +
														'/' +
														data.item
															.receipt_location
														" class="btn btn-sm text-white akkurate-gray-btn custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'download',
														]" /></span>
													</a>
													<a v-if="
														data.item.status ==
														'DISBURSED'
													" :disabled="isReversing" title="Reverse" @click="
														reverseVoucher(
															data.item.id
														)
														" class="btn btn-sm akkurate-blue text-white custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'arrow-rotate-left',
														]" /></span>
													</a>
												</span>
											</template>
										</b-table>
										<div class="d-flex justify-content-between">
											<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
												:total-rows="totalRecords" :per-page="perPage"
												aria-controls="voucher-table"></b-pagination>
											<!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
											<div class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group label="Per Page" label-size="sm" class="mb-0">
													<b-form-select @change="selectPerPage" id="per-page-select"
														v-model="perPage" :options="per_page_options
															" size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div>
									</div>

									<b-modal size="xl" id="bv-modal-example">
										<template #modal-title>
											<h6 class="akkurate-green fw-bold">
												Voucher Payment
											</h6>
										</template>
										<print-voucher :data="voucherData" :institution="institution"
											ref="printVoucher"></print-voucher>
										<template #modal-footer>
											<div class="w-100">
												<!-- Emulate built in modal footer ok and cancel button actions -->
												<b-button @click="handleGeneratePDF" type="button"
													class="akkurate-green-btn download-btn ms-2 float-right"><span
														class="small"><font-awesome-icon :icon="[
															'fas',
															'book',
														]" />
														Print</span></b-button>
												<b-button @click="handleExportToPDF"
													class="akkurate-green-btn download-btn float-right"><span
														class="small"><font-awesome-icon :icon="[
															'fas',
															'save',
														]" />
														Download</span></b-button>
											</div>
										</template>
									</b-modal>
								</div>
							</div>
						</div>
					</div>
					<!-- end row  -->
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";

import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from "vue-multiselect";
import Reject from "../forms/modal/Reject.vue";
import ExcelJS from "exceljs";
import PrintVoucher from "../report/PrintVoucher.vue";
import VoucherView from "../view/VoucherView.vue";
import JournalVoucherFilter from "../../journal/JournalVoucherFilter.vue";
import { hasPermission } from "@/helper";

// import $ from 'jquery';
// import 'datatables.net';
// import JwtService from "@/core/services/jwt.service";
import config from "@/config.js";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
		Reject,
		VoucherView,
		PrintVoucher,
		JournalVoucherFilter,
		ChatBot,
	},
	mounted() {
		let token = localStorage.getItem("token");
		if (!token) {
			this.$router.push({ path: "/login" });
		}
		this.getVoucherDropdown();
		this.configBase = config?.base_url;
		this.loadItems();
		this.checkPemission();
	},

	data() {
		return {
			totalRecords: 0,
			searchFilter: "",
			configBase: "",
			isLoading: false,
			form: {
				status: "",
				branch: [],
				start_date: "",
				end_date: "",
				users: [],
			},
			isDisbursing: false,
			// branch_arr: [],
			// status_arr: [],
			users_options: [],
			status_options: [
				"PENDING",
				"APPROVED",
				"REJECTED",
				"DISBURSED",
			],
			branch_options: [],
			isReversing: false,
			// users_arr: [],
			more_details: false,
			voucherData: {},
			institution: {},
			currentPage: 1,
			perPage: 10,
			per_page_options: ["10", "20", "50", "100", '500', '1000', '5000', '10000'],
			per_page_selected: "10",
			isBusy: false,
			total_amount_requested: "",
			total_amount_approved: "",
			fields: [
				{
					label: "Code",
					key: "code",
				},
				{
					label: "Date",
					key: "recorded_date",
				},
				{
					label: "Reference",
					key: "reference",
				},
				{
					label: "Beneficiary_Name",
					key: "beneficiary_name",
				},

				{
					label: "Branch",
					key: "branch.name",
				},
				{
					label: "Amt_Requested",
					key: "amount_requested",
				},
				{
					label: "Narration",
					key: "narration",
				},
				{
					label: "Status",
					key: "status",
				},
				{
					label: "Created_By",
					key: "created_by",
				},
				{
					label: "Actions",
					key: "actions",
					//   formatFn: this.renderActions,
				},
			],
			rows: [],
			status_permission: false,
		};
	},
	methods: {
		statusBadge(item) {
			if (item === "APPROVED") {
				return "badge akkurate-blue";
			} else if (item === "REJECTED") {
				return "badge akkurate-gray-bg";
			} else if (item === "DISBURSED") {
				return "badge akkurate-green-bg";
			} else if (item === "PENDING") {
				return "badge akkurate-warning-bg";
			} else if (item === "REVERSED") {
				return "badge akkurate-danger-bg";
			} else {
				return "badge akkurate-warning-bg";
			}
		},
		rowClass() {
			return "custom-row-height";
		},
		filterTable() {
			this.loadItems();
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},

		async getVoucherDropdown() {
			this.$Progress.start();
			await ApiService.get("/vouchers/dropdown")
				.then((response) => {
					this.$Progress.finish();
					this.branch_options = response.data.branches;
					this.users_options = response.data.users;
					this.institution = response.data.institution;
				})
				.catch((error) => {
					this.$Progress.fail();
					console.log(error);
				});
		},
		// load items is what brings back the rows from server
		async loadItems() {
			this.isBusy = true;
			this.isLoading = true;
			let users = [];
			let branches = [];
			//Reduce Users Array Object For Filters
			users = this.form.users?.reduce((accumulator, currentValue) => {
				accumulator.push(currentValue.id);
				return accumulator;
			}, []);
			//Reduce Branch Array Object For Filters
			branches = this.form.branch?.reduce(
				(accumulator, currentValue) => {
					accumulator.push(currentValue.id);
					return accumulator;
				},
				[]
			);

			await ApiService.post("/vouchers/paginate", {
				page: this.currentPage,
				per_page: this.perPage,
				filter: this.form.search,
				branch_ids: branches, //Eg. 1, 2, etc
				statuses: this.form.status,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				users_ids: users,
			})
				.then((response) => {
					// console.log(response.data.data);
					this.isBusy = false; // Set isBusy to false when the data is loaded
					this.$Progress.finish(); // Finish the progress bar

					this.totalRecords = response.data.meta.total;
					this.rows = response.data.data; // Return data to populate the table
					this.total_amount_requested =
						response.data.meta.total_amount_requested;
					this.total_amount_approved =
						response.data.meta.total_amount_approved;

					console.log(response.data.meta.total_amount_requested);
				})
				.catch(() => {
					// console.log(error);
					this.isLoading = false;
				})
				.finally(() => {
					// this.isLoading = false
					this.isLoading = false;
				});
		},
		rejected() {
			// this.loadItems();
		},

		printVoucher(row) {
			this.voucherData = row;
			this.$nextTick(() => {
				this.$bvModal.show("bv-modal-example");
			});
		},
		async disburseVoucher(index) {
			swal.fire({
				title: "Disburse Voucher",
				text:
					"Are you sure you want to disburse voucher " +
					index +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-danger-bg modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					this.isDisbursing = true;
					ApiService.post(`/vouchers/disburse/${index}`)
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response?.data?.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`I${institutionDetailsRow}`).value = institutionName;
				ws.getCell(`I${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

				ws.getCell(`I${institutionDetailsRow + 1}`).value = institutionAddress;
				ws.getCell(`I${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

				ws.getCell(`I${institutionDetailsRow + 2}`).value = institutionMotto;
				ws.getCell(`I${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 3}`).value = institutionPhone;
				ws.getCell(`I${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 4}`).value = institutionEmail;
				ws.getCell(`I${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn('J').width = 50;  // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Recorded Date",
					"References",
					"Code",
					"Branch",
					"Amount",
					"Narration",
					"Status",
					"Created by",
				];



				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.rows.forEach(item => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.recorded_date,
						`VOU${item.id}`,
						item.code,
						item.branch.name,
						item.amount_requested,
						item.narration,
						item.status,
						item.created_by?.first_name + " " + item.created_by?.surname,
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "voucher_export.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		show_more() {
			this.more_details = !this.more_details;
		},
		handleGeneratePDF() {
			// Call the generatePDF method inside the print-voucher component
			this.$refs.printVoucher.generatePDF();
		},
		handleExportToPDF() {
			// Call the exportToPDF method inside the print-voucher component
			this.$refs.printVoucher.exportToPDF();
		},
		reverseVoucher(index) {
			swal.fire({
				// title: response.data.transaction.trans_status,
				title: "Reverse Voucher",
				// text: 'CODE : ' + response.data.transaction.code,
				text: "Are you sure?",
				confirmButtonColor: "#018673",
				icon: "question",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "No", // Customize the text for the "OK" button
				cancelButtonText: "Yes", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-bg modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.isDisbursing = false;
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = true;
					this.isDisbursing = false;
					this.$Progress.start();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
					await ApiService.post(`/vouchers/reverse/${index}`)
						.then((response) => {
							console.log(response);
							this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: response.data.message,
							});
							this.loadItems();
						})
						.catch((error) => {
							this.isDisbursing = false;
							this.isLoading = false;
							this.$Progress.fail();
							toast.fire({
								icon: "error",
								title: error.response.data.message,
							});
							// if (error.response.data.errors) {
							//     this.form.errors = error.response.data.errors;
							// }
						});
				}
			});
		},

		checkPemission() {
			 this.status_permission = hasPermission("voucher_management_edit");
			 console.log(this.status_permission);
		},
	},
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
